export default __webpack_public_path__ + "static/media/HojadeVida.a0ec9b95.pdf";